import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { AuthService } from '../_services/api/auth.service';
import { UserProfileService } from '../_services/app/profile.service';

@Injectable({ providedIn: 'root' })
export class ProfileResolver implements Resolve<boolean> {
  constructor(private profileService: UserProfileService, private authService: AuthService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    if (!this.authService.isLoggedIn()) {
      return of(true);
    }
    return this.profileService.profile$.pipe(
      take(1),
      switchMap(profile => {
        if (!profile) {
          return this.profileService.refreshProfile().pipe(
            map(() => true)
          );
        }
        return of(true);
      }),
      catchError(() => {
        return of(true);
      })
    );
  }
}